export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/men.2dc0372.svg";